import { OFFERS_FILTERS } from 'modules/product/views/components/product-offers-header/data/filter-options.data';
import OfferInterface from 'interfaces/offer.interface';
import { RATES_PATTERN_WORDS } from 'modules/product/views/components/product-offers/components/rates';
import { FREE_DELIVERY_PATTERN_WORDS } from 'modules/product/views/components/product-offers/components/delivery';
import { shouldShowOfferBadge } from 'helpers/get-filters-offers-count';

export default function hasActiveFilter(
    activeFilters: string[] = [],
    offer: OfferInterface
): boolean {
    if (!activeFilters.length) {
        return true;
    }

    return activeFilters.every(filter => {
        if (filter === OFFERS_FILTERS.IS_AUTHORIZED) {
            return Boolean(offer.dealer.producer?.config.badges.authorized);
        }

        if (filter === OFFERS_FILTERS.OPINEO_CERTIFICATE) {
            return offer.dealer.opinions?.badges.credibilityVerification;
        }

        if (filter === OFFERS_FILTERS.PERSONAL_RECEIPT) {
            return offer.dealer.shippings?.some(item => item.service === 'Odbiór osobisty');
        }

        if (filter === OFFERS_FILTERS.DELIVERY_24H && offer.availability?.label === 'Wysyłka w 24h') {
            return true;
        }

        if (filter === OFFERS_FILTERS.RATES) {
            return offer.dealer.badges.some(item => {
                return (
                    item.type === filter
                    && shouldShowOfferBadge(item, offer.description, RATES_PATTERN_WORDS)
                );
            });
        }

        if (filter === OFFERS_FILTERS.FREE_DELIVERY) {
            return offer.dealer.badges.some(item => {
                return (
                    item.type === filter
                    && shouldShowOfferBadge(item, offer.description, FREE_DELIVERY_PATTERN_WORDS)
                );
            });
        }

        return offer.dealer.badges.some(item => item.type === filter);
    });
}
